import { useEffect, useState } from "react";
import { Backdrop, Box, Typography, Paper } from "@mui/material";
import ScreenRotationIcon from "@mui/icons-material/ScreenRotation";

const RotateOverlay = () => {
  const [open, setOpen] = useState(false);

  const checkOrientation = () => {
    const isTablet =
      window.innerWidth >= 600 && window.innerWidth <= 1024;

    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    setOpen(isTablet && isPortrait);
  };

  useEffect(() => {
    checkOrientation();
    window.addEventListener("resize", checkOrientation);
    window.addEventListener("orientationchange", checkOrientation);

    return () => {
      window.removeEventListener("resize", checkOrientation);
      window.removeEventListener("orientationchange", checkOrientation);
    };
  }, []);

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(25px)",
        WebkitBackdropFilter: "blur(25px)",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: 3,
          maxWidth: 320,
        }}
      >
        <ScreenRotationIcon sx={{ fontSize: 48, mb: 2 }} />
        <Typography variant="h6" fontWeight={600}>
          Rotate your device
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, opacity: 0.8 }}>
          This screen works best in landscape mode
        </Typography>
      </Paper>
    </Backdrop>
  );
};

export default RotateOverlay;

